import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { getLightColour } from "./Util";

export default function ErrorModal(props) {
  const [opacity, setOpacity] = useState(0);

  useEffect(() => setOpacity(1), []);

  return (
    <Modal show={props.show} onHide={props.close} dialogClassName="errorModal">
      <Modal.Header style={{ backgroundColor: getLightColour() }} closeButton>
        <Modal.Title>Error</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ opacity, height: props.height + "px" }}>
        <span className="errorMessage">{props.error}</span>
      </Modal.Body>
    </Modal>
  );
}
